import { FormQuestion, SelectOption } from '@percent/grants-nomination-form/api/nominationForm/nominationForm.types';
import { useNominationForm } from '@percent/grants-nomination-form/hooks';
import { useFormContext } from 'react-hook-form';

const setValueOptions = { shouldValidate: true, shouldTouch: false };

export const useConditionalSelect = (question: FormQuestion) => {
  const { setValue } = useFormContext();
  const { setVisibleQuestions, nominationFormData } = useNominationForm();

  const handleConditionalSelectChange = (selectedValues: string[]) => {
    if (question.type !== 'select') return;

    const options = question.options ?? [];
    const hasConditionals = options.some((o: SelectOption) => o.conditionalQuestionIds?.length);

    if (!hasConditionals) return;

    const newVisibility: Record<string, boolean> = {};

    for (const option of options) {
      if (!option.conditionalQuestionIds?.length) {
        // eslint-disable-next-line no-continue
        continue;
      }

      const isSelected = selectedValues.includes(option.value);

      for (const condId of option.conditionalQuestionIds) {
        newVisibility[condId] = isSelected || (newVisibility[condId] ?? false);
      }
    }

    setVisibleQuestions(newVisibility);

    const allQuestions = nominationFormData?.pages.flatMap((page) => page.questions) ?? [];

    for (const [condId, visible] of Object.entries(newVisibility)) {
      if (!visible) {
        const condQuestion = allQuestions.find((q) => q?.id === condId);

        if (condQuestion) {
          setValue(condQuestion.key, undefined, setValueOptions);
        }
      }
    }
  };

  return { handleConditionalSelectChange };
};
